import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/partners/fetch-fune-up/{dossier}'
*/
const FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4.url(args, options),
    method: 'post',
})

FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-fune-up/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/partners/fetch-fune-up/{dossier}'
*/
FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/partners/fetch-fune-up/{dossier}'
*/
FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/dossier/{dossier}/funeup'
*/
const FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9 = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.url(args, options),
    method: 'get',
})

FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/funeup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/dossier/{dossier}/funeup'
*/
FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/dossier/{dossier}/funeup'
*/
FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController.php
* @route '/api/dossier/{dossier}/funeup'
*/
FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierFuneUpController::FetchDossierFuneUpController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierFuneUpController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierFuneUpController = {
    '/api/partners/fetch-fune-up/{dossier}': FetchDossierFuneUpController9f280dc58d38eaa66911548f2ec2aff4,
    '/api/dossier/{dossier}/funeup': FetchDossierFuneUpController88b4534cbf4e3b8b416374c32b7e16e9,
}

export default FetchDossierFuneUpController